import { apiFetch } from '@/shared/api/client'
import { runKitchenSync } from '@/shared/sync/kitchenSync'
import { shouldUseDelmanMock } from '@/features/delman/api/delmanApiMode'

export type StartTripRequest = {
  tripId: string
  deviceId: string
}

export type StartTripResponse = {
  started_at: string
}

async function mockStartTrip(): Promise<StartTripResponse> {
  await new Promise((r) => setTimeout(r, 400))
  return { started_at: new Date().toISOString() }
}

export async function startTripDirect(req: StartTripRequest): Promise<StartTripResponse> {
  if (shouldUseDelmanMock()) {
    return mockStartTrip()
  }

  return apiFetch<StartTripResponse>(`/delivery-trips/${encodeURIComponent(req.tripId)}/start`, {
    method: 'PATCH',
    body: JSON.stringify({ device_id: req.deviceId }),
  })
}

export async function startTrip(req: StartTripRequest): Promise<StartTripResponse> {
  return runKitchenSync(
    {
      type: 'delman_start_trip',
      label: `Mulai trip ${req.tripId}`,
      payload: req,
    },
    () => startTripDirect(req),
    () => ({ started_at: new Date().toISOString() }),
  )
}
